import { render, staticRenderFns } from "./SelectLabel.vue?vue&type=template&id=1fe20518&lang=pug&"
import script from "./SelectLabel.vue?vue&type=script&lang=js&"
export * from "./SelectLabel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports